import { euro } from '../format';
import type { ScanOutcome } from '../pos/cart';
import type { CartLine, LocalSale } from '../pos/types';

/** Reine Hilfen der Kassen-Seite (`pos.tsx`): Typen, Konstanten und Funktionen ohne Zustand. */

export type Warning = Extract<ScanOutcome, { kind: 'warning' }>;
/** Rückfrage vor Storno; `correct` = „Korrigieren“ (Storno und Zeilen zurück in den Warenkorb, K5). */
export type VoidAsk = {
  sale: LocalSale;
  lineNo?: number | undefined;
  correct?: boolean | undefined;
};

export type Stage = 'scan' | 'pay' | 'done';
export type Panel =
  'sync' | 'sales' | 'last' | 'device' | 'search' | 'handover' | 'menu' | 'park' | null;

/** Uhrzeit in ms: ein Aufruf aus Ereignissen und Warteschlange, nie beim Zeichnen. */
export const clockMs = (): number => Date.now();

/** Uhrzeit des Artikelstands (Berliner Zeit, wie die Verkäufe). */
export const standTime = new Intl.DateTimeFormat('de-DE', {
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Europe/Berlin',
});

/**
 * Mit Maus/Trackpad (Notebook) öffnet der Fokus keine Bildschirmtastatur. Am Handy und Tablet hält die Kasse den Fokus
 * trotzdem im Codefeld (Handscanner, HID), dann aber mit `inputMode="none"`, bis man das Feld antippt.
 */
export function finePointer(): boolean {
  return typeof window.matchMedia === 'function' && window.matchMedia('(pointer: fine)').matches;
}

/** Betrag, der bei einem Storno an den Kunden zurückgeht. */
export function refundCents(sale: LocalSale, lineNo?: number): number {
  if (lineNo !== undefined) return sale.lines[lineNo - 1]?.priceCents ?? 0;
  return sale.lines.reduce((sum, line) => sum + (line.voided ? 0 : line.priceCents), 0);
}

export const lineText = (line: CartLine): string =>
  `✓ ${line.sellerNumber === null ? '?' : `V${String(line.sellerNumber)}`} · ${line.title} · ${euro(line.priceCents)}`;
